import { isEmpty } from 'ramda'

import SimpleDate from 'app/common/classes/simple-date'
import { getValue } from 'app/common/ui-components/filter'
import detailsFilter from 'app/components/common/reports/filters/details'
import customerTypeFilter from 'app/components/common/reports/filters/customerType'
import classFilter from 'app/components/common/reports/filters/class'

import groupFilter from '../ReportFilter/filters/group'
import periodFilter, { dateFormat as dateFormatPeriod } from '../ReportFilter/filters/period'

type State = Record<string, any>

export const isDetailsNotAvailable = (state: State) => {
  const [detailsFilterValue] = getValue(detailsFilter, state)
  const [groupFilterValue] = getValue(groupFilter, state)
  const customerType = getValue(customerTypeFilter, state)
  const classes = getValue(classFilter, state)
  const [from, to] = getValue(periodFilter, state)
  const dateFrom = new SimpleDate(from, dateFormatPeriod)
  const dateTo = new SimpleDate(to, dateFormatPeriod)
  const period = dateFrom.daysBefore(dateTo)

  if (period === null || period === 0) return false
  // период в один день (указан тот же самый день) или ошибка в дате - детализация доступна
  // ошибка в дате невозможа здесь

  return (
    detailsFilterValue === 'details' &&
    groupFilterValue === 'by_purchases' &&
    (isEmpty(customerType) ||
      (customerType.length === 1 &&
        customerType.includes('Учащиеся') &&
        (isEmpty(classes) || classes.length > 1)))
  )
}
